import { render, staticRenderFns } from "./SourcePickerInput.vue?vue&type=template&id=680dd440&scoped=true&"
import script from "./SourcePickerInput.vue?vue&type=script&lang=js&"
export * from "./SourcePickerInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680dd440",
  null
  
)

export default component.exports